import { pick } from 'lodash';
import type { ReadonlyDeep } from 'type-fest';

import type { MutationLoginArgs } from '@e-socna/data-layer';

export function credentialsForm2ApiMapper(
  credentials: ReadonlyDeep<MutationLoginArgs>,
): ReadonlyDeep<MutationLoginArgs> {
  return pick(credentials, ['email', 'password']);
}
